import { createContext } from "react";

const AuthContext = createContext({
  isLoggedIn: false,
  userInfo: {},
  token: null,
  formFields: [],
  userPhoneNumber: () => {},
  userLogin: () => {},
  userVerify: () => {},
  userCompleteProfile: () => {},
  userLogout: () => {},
  userPasswordRecovery: () => {},
});

export default AuthContext;